/* eslint-disable react/prop-types */
import Page from '../../components/Page';
import useLocales from "../../hooks/useLocales";
import Layout from '../../layouts';
import { findCategoriesAPI } from "../../service/gplx.category.service";

/* eslint-disable react/prop-types */
import { Box, Button, Card, CardContent, Container, Divider, Grid, Stack, Typography, styled, useTheme } from "@mui/material";
import Link from 'next/link';
import AdsContact from '../../components/AdsContact';
import AppSection from "../../components/AppSection";
import { GoogleBannerAds, GoogleGridAds } from '../../components/GoogleAds';
import HackerthonAds from '../../components/HackerthonAds';
import TextMaxLine from '../../components/TextMaxLine';
import { PreviewYoutube } from '../../components/YoutubePlayer';
import useResponsive from "../../hooks/useResponsive";
import useSettings from "../../hooks/useSettings";
import Claimnation from '../../sections/situation/Claimnation';
import MenuSection from '../../sections/situation/MenuSection';
import { SituationHeader } from '../../sections/situation/SituationHeader';
import SituationWelcome from '../../sections/situation/SituationWelcome';

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
  },
}));

Situation.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function Situation({ categories }) {
  const { translate } = useLocales();
  const isDesktop = useResponsive('up', 'sm');
  const { themeStretch } = useSettings();

  return (
    <Page title={translate('situation.title')} description={translate('situation.description')} imagePath="/slider/mo-phong.jpg">
      <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
        <RootStyle>
          <Grid container spacing={3} mb={5}>
            <Grid item xs={12} md={8}>
              <SituationWelcome />
            </Grid>
            <Grid item xs={12} md={4}>
              <AdsContact />
            </Grid>
          </Grid>
          <SituationHeader />
          <Grid container mb={5} spacing={1}>
            <Grid item xs={12} md={3}>
              <MenuSection categories={categories} />
              {isDesktop && <Stack mt={2} spacing={2}>
                <Divider />
                <AppSection />
                <HackerthonAds />
                <GoogleBannerAds />
              </Stack>}
            </Grid>
            <Grid item xs={12} md={9}>
              <CategorySection categories={categories} />
              <PreviewYoutube videoId={"sUM8LgbJnMA"} autoplay={false} />
              <Claimnation />
              {!isDesktop && <Stack p={1} spacing={2}>
                <HackerthonAds />
                <GoogleBannerAds />
                <Divider />
              </Stack>}
            </Grid>
          </Grid>
          <Grid container my={3} >
            <Grid item xs={12} md={12}>
              <GoogleGridAds />
            </Grid>
          </Grid>
        </RootStyle>
      </Container>
    </Page >
  );
}

function CategorySection({ categories }) {
  const theme = useTheme();

  return (
    <Box padding={3} bgcolor={theme.palette.background.neutral}>
      <Stack spacing={2} >
        <Typography variant='h5' color={"primary.dark"}>PHẦN MỀM ÔN TẬP MÔ PHỎNG 120 TÌNH HUỐNG GIAO THÔNG TRONG HỌC LÁI XE Ô TÔ</Typography>
        <Typography variant='body'>Phần mềm mô phỏng 120 tình huống giao thông được áp dụng vào chương trình dạy và học lái xe ô tô các hạng B1, B2, C, D, E, F.
          Dựa trên những bổ sung quan trọng của Tổng cục đường bộ Việt Nam, onthibanglaixe.net biên soạn và phát triển phần mềm thi thử mô phỏng 120 tình huống giao thông online.</Typography>
        <Typography variant='body'>Phần mềm này mô phỏng lại các tình huống thực tế khi tham gia giao thông, trong đó cấu trúc nội dung được chia ra như sau:</Typography>
        <Typography variant='body1'>
          <Typography component="span" color={"red"} variant='subtitle1'>Hướng dẫn:</Typography> Nhấn phím Cách (Space) để xác nhận, nhấn phím → ← để chuyển câu.
        </Typography>
      </Stack>
      <Grid container spacing={2} mt={1}>
        {categories.map((c, index) => (
          <Grid item xs={12} sm={6} key={c.id}>
            <Link href={`/thi-tinh-huong/${categories[index]?.situations[0]?.slug}`} passHref scroll={false}>
              <Card sx={{ height: '100%', cursor: 'pointer' }}>
                <CardContent>
                  <Typography variant='subtitle1'>{c.title}</Typography>
                  <Divider sx={{ my: 1 }} />
                  <TextMaxLine variant='body2' line={4} persistent>{c.metaDescription}</TextMaxLine>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}
        <Grid item xs={12} sm={12} sx={{ textAlign: 'center' }}>
          <Link href={`/thi-tinh-huong/${categories[0]?.situations[0]?.slug}`} passHref scroll={false}>
            <Button variant='contained' size='large' sx={{ width: 200 }}>
              BẤT ĐẦU
            </Button>
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
}

export async function getStaticProps() {
  // Fetch necessary data for the blog post using params.id
  const search = { page: 0, size: 10, value: '%%', orders: [{ order: 'asc', property: 'orderNo', },], };

  const { code, data: categories } = await findCategoriesAPI(search);

  if (code !== "200") {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      categories
    },
  };
}